module.exports = __webpack_public_path__ + "static/architecture-e849c8c40690a6f5d4fee635062a73a9.svg";